import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type Session from "cc-frontend/services/session"

interface Signature {
  Args: {
    toggleCardMenu: () => void
    usedAs: string
    addCardToBottom: () => void
    goToAddCard: () => void
  }
}

export default class AddCardBody extends Component<Signature> {
  @service declare session: Session
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::AddCard::Primary::Body": typeof AddCardBody
  }
}
